import React, {FC, ReactElement, useMemo} from 'react';

import {TextField, TextFieldProps} from "@mui/material";
import {DatePicker as MuiDatePicker, DatePickerProps as MuiDatePickerProps} from "@mui/lab";
import {Moment} from "moment";
import {DATE_MASK, DATE_PATTERN} from "../../utils/DataFormat";

type PickerType = Moment | undefined | null

interface DatePickerProps extends Omit<MuiDatePickerProps<PickerType>, "renderInput"> {
    error?: React.ReactNode,
    value: PickerType
}

export const DatePicker: FC<DatePickerProps> = (props): ReactElement => {
    const componentProps: MuiDatePickerProps<PickerType> = useMemo(() => {
        const renderInput = (params: TextFieldProps) => {
            const error = props.error;
            const errorProps = error ? {
                error: true,
                helperText: error
            } : {}
            return (<TextField {...params} {...errorProps} />)
        };

        const onChange = (newDate: PickerType | null) => {
            if ((!props.value && newDate) || (props.value && !newDate)) {
                props.onChange(newDate);
            }
            if (props.value && newDate) {
                if (newDate.isValid() && !props.value.isSame(newDate)) {
                    props.onChange(newDate);
                }
            }
        }
        return {
            inputFormat: DATE_PATTERN,
            mask: DATE_MASK,
            renderInput,
            ...props,
            onChange,
        }
    }, [props])

    return <React.Fragment key={props.value?.toJSON() ?? ""}>
        <MuiDatePicker<PickerType>
                {...componentProps}
        />
    </React.Fragment>
}